import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon, SimpleModal } from '@livable/saas-react-components';
import { Button } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SendReportModalContent from './content';
const SendReportModal = _ref => {
  let disabled = _ref.disabled,
    properties = _ref.properties,
    variant = _ref.variant;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    modalIsOpen = _useState2[0],
    setModalIsOpen = _useState2[1];
  const defaultTrigger = /*#__PURE__*/React.createElement(Button, {
    disabled: disabled,
    onClick: () => setModalIsOpen(true),
    variant: variant || 'actionButton',
    'custom-attribute': '7-send-report-modal'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "message"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('reporting.send_report')));
  return /*#__PURE__*/React.createElement(SimpleModal, {
    handleClose: () => setModalIsOpen(false),
    isOpen: modalIsOpen,
    noFooter: true,
    noPadding: true,
    title: t('reporting.send_report'),
    trigger: defaultTrigger
  }, /*#__PURE__*/React.createElement(SendReportModalContent, {
    properties: properties
  }));
};
export default SendReportModal;